import { HttpClient, HttpMethod, HttpStatusCode } from '@hub-la/fe-core-http-client'
import { inject } from 'inversify'
import { GetMovementsRequestDto, MovementDto } from '../domain/dtos/get-moviments.dto'
import { GeneralError } from '../domain/errors/general'
import { Envs } from '../envs'

export class GetMovementsByInvoiceId {
  public constructor(
    @inject(HttpClient)
    private readonly httpClient: HttpClient,
  ) {}

  public async execute(input: GetMovementsRequestDto): Promise<MovementDto[]> {
    const response = await this.httpClient.request({
      method: HttpMethod.GET,
      url: `${Envs.BFF_WEB_URL}/financial-statement/invoices/${input.invoiceId}/movements`,
    })

    if (response.statusCode === HttpStatusCode.OK) {
      return response.data
    }

    throw new GeneralError()
  }
}
